import FeedbackButton from './FeedbackButton'

export default FeedbackButton
